module.exports = __webpack_public_path__ + "static/media/48.d59d36e1.png";